// extracted by mini-css-extract-plugin
module.exports = {"sidebarlink":"sidebar-link_sidebarlink__a7hUN","label":"sidebar-link_label__IGX7T"};